<template>
    <div class="o-crop">
        <template v-if="crop">
            <m-title :title="crop.name" />
            <div class="l-row">
                <div class="l-row__column">
                    <template v-if="crop.crop_type && crop.crop_type.name">
                        <p class="a-label">Rodzaj</p>
                        <p class="a-text">{{ crop.crop_type.name }}</p>
                    </template>
                    <template v-if="crop.ingredients">
                        <p class="a-label">Składniki</p>
                        <p class="a-text">{{ crop.ingredients }}</p>
                    </template>
                </div>
            </div>
            <div class="l-row" v-if="crop.description && descriptionWithoutTags">
                <div class="l-row__column">
                    <p class="a-label">Informacje o produkcie</p>
                    <p class="a-text" v-html="crop.description"></p>
                </div>
            </div>
            <m-gallery
                v-if="crop.photos && crop.photos.length > 0"
                :images="photos"
            />
            <template v-if="crop.protectors && crop.protectors.length > 0">
                <m-tabs
                    id="protectors"
                    v-if="cropRelated"
                    :items="cropRelated"
                    @input="tab = $event.value"
                    :selected="tab"
                    :center="true"
                />
                <m-list
                    router-single-name="protector"
                    :list="crop.protectors"
                >
                    <template slot="list" slot-scope="props">
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                                :src="props.item.photos.find(item => item.is_main === true).full_uri"
                                :alt="props.item.name"
                            />
                            <figure
                                v-else
                                class="a-image"
                            ></figure>
                        </div>
                        <p
                            class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                            :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                        >
                            {{ props.item.name }}
                             <span
                                v-if="props.item.is_deleted"
                                class="m-list__itemTitleRed"
                            >
                                <br />archiwalny
                            </span>
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="props.item.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                            />
                        </div>
                    </template>
                </m-list>
            </template>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    data() {
        return {
            tab: '',
            metaTitle: 'Uprawa'
        }
    },
    computed: {
        crop() {
            return this.$store.getters.crop
        },
        cropStatus() {
            return this.$store.getters.cropStatus
        },
        cropRelated() {
            if(this.crop.protectors.length > 0) {
                return [{
                    value: 'protectors',
                    label: 'Powiązane środki'
                }]
            } else {
                return null
            }
        },
        descriptionWithoutTags() {
            return this.crop.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.crop.photos.map(item => item.full_uri)
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetchCrop() {
            if(!isNaN(this.$route.params.id)) {
                this.$store.dispatch('fetchCrop', this.$route.params.id).then(() => {
                    this.metaTitle = this.crop.name
                    // init tabs
                    if(this.crop.protectors && this.crop.protectors.length > 0) {
                        this.tab = 'protectors'
                    }
                })
            } else {
                this.$router.push({ name: 'error404' })
            }
        }
    },
    created() {
        this.fetchCrop()
    }
}
</script>